module.exports = __webpack_public_path__ + "img/linkedin.52fba926.svg";